var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBin = function SvgBin(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 65,
    height: 64,
    viewBox: "0 0 65 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 64,
    height: 64,
    rx: 32,
    fill: "#F4F0F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 24H23.1667H44.5",
    stroke: "#5C068C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8334 23.9998C42.8334 23.4476 42.3856 22.9998 41.8334 22.9998C41.2811 22.9998 40.8334 23.4476 40.8334 23.9998H42.8334ZM24.1667 23.9998C24.1667 23.4476 23.719 22.9998 23.1667 22.9998C22.6144 22.9998 22.1667 23.4476 22.1667 23.9998H24.1667ZM26.1667 23.9998C26.1667 24.5521 26.6144 24.9998 27.1667 24.9998C27.719 24.9998 28.1667 24.5521 28.1667 23.9998H26.1667ZM36.8334 23.9998C36.8334 24.5521 37.2811 24.9998 37.8334 24.9998C38.3856 24.9998 38.8334 24.5521 38.8334 23.9998H36.8334ZM40.8334 23.9998V42.6665H42.8334V23.9998H40.8334ZM40.8334 42.6665C40.8334 43.587 40.0872 44.3332 39.1667 44.3332V46.3332C41.1917 46.3332 42.8334 44.6915 42.8334 42.6665H40.8334ZM39.1667 44.3332H25.8334V46.3332H39.1667V44.3332ZM25.8334 44.3332C24.9129 44.3332 24.1667 43.587 24.1667 42.6665H22.1667C22.1667 44.6915 23.8083 46.3332 25.8334 46.3332V44.3332ZM24.1667 42.6665V23.9998H22.1667V42.6665H24.1667ZM28.1667 23.9998V21.3332H26.1667V23.9998H28.1667ZM28.1667 21.3332C28.1667 20.4127 28.9129 19.6665 29.8334 19.6665V17.6665C27.8083 17.6665 26.1667 19.3081 26.1667 21.3332H28.1667ZM29.8334 19.6665H35.1667V17.6665H29.8334V19.6665ZM35.1667 19.6665C36.0872 19.6665 36.8334 20.4127 36.8334 21.3332H38.8334C38.8334 19.3081 37.1917 17.6665 35.1667 17.6665V19.6665ZM36.8334 21.3332V23.9998H38.8334V21.3332H36.8334Z",
    fill: "#5C068C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M29.8333 30.6665V38.6665",
    stroke: "#5C068C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M35.1667 30.6665V38.6665",
    stroke: "#5C068C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBin);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/bin.8b1f19779ce9a2a023692576fade4736.svg";